import '../ui/vendor/fontawesome/fontawesome-blog.font';
require('./blog.component.scss');
require('../pages/focused-layout.scss');

export class BlogComponent {
    public component: JQuery;
    public componentName = `blog`;
    public toggleQuestion: JQuery;

    constructor() {
        this.component = $(`[data-component='${this.componentName}']`);
        this._onInit();
    }

    private _onInit() {
        this._performElementBinding();
        this._registerEventHandlers();
    }

    /**
     * Binds component properties to jQuery selectors
     * @private
     */
    private _performElementBinding() {
        this.toggleQuestion = this.component.find(`[data-binding='toggleQuestion']`);
    }

    /**
     * Registers event handlers on component properties
     * @private
     */
    private _registerEventHandlers() {
        if (this.toggleQuestion) {
            this.toggleQuestion.on(`click`, (e) => {
                const getContainer =
                    $(e.target).parents('[data-binding="toggleQuestion"]').length > 0
                        ? $(e.target).parents('[data-binding="toggleQuestion"]')
                        : $(e.target);

                $(getContainer).next(`[data-binding="question"]`).toggle();
                if ($(getContainer).next(`[data-binding="question"]`).is(':visible')) {
                    $(getContainer).find(`.fa`).addClass(`fa-angle-up`);
                } else {
                    $(getContainer).find(`.fa`).removeClass(`fa-angle-up`);
                }
            });
        }
    }
}
